/* Pattern styles */
import "./pattern.scss";

wp.domReady(() => {

    let modalSlideshows = document.querySelectorAll('[data-pattern="modal-slideshow"]');

    if( modalSlideshows ) {
        modalSlideshows.forEach((modalSlideshow) => {
            /**
             * Create the modal buttons
             *
             * These buttons will replace the default cross and x buttons from
             * the block pattern
             */
            const openSVG = getOpenButton();
            const closeSVG = getCloseButton();

            // Replace the default buttons with the new ones
            const openButton = modalSlideshow.querySelector('.modal-slideshow__modal > button');
            const closeButton = modalSlideshow.querySelector('.modal-slideshow__modal .bod-block-close-btn > button');

            // Replace button content
            openButton.innerHTML = '';
            openButton.appendChild(openSVG);
            closeButton.innerHTML = '';
            closeButton.appendChild(closeSVG);
        });
    }
});

/**
 * Create the close button for the modal
 *
 * @returns {Element}
 */
function getCloseButton() {
    let closeButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    closeButton.setAttribute('width', '24');
    closeButton.setAttribute('height', '24');
    closeButton.setAttribute('viewBox', '0 0 24 24');

    let closeButtonPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    closeButtonPath.setAttribute('d', 'M21,24H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H21a3,3,0,0,1,3,3V21A3,3,0,0,1,21,24ZM11.9,13.406h0l3.388,3.388,1.508-1.507L13.406,11.9l3.389-3.389L15.286,7,11.9,10.389,8.509,7,7,8.509,10.389,11.9,7,15.287l1.508,1.507L11.9,13.406Z');
    closeButtonPath.setAttribute('transform', 'translate(0 0)');
    closeButtonPath.setAttribute('fill', '#fff');

    closeButton.appendChild(closeButtonPath);

    return closeButton;
}

/**
 * Create the open button for the modal
 *
 * @returns {Element}
 */
function getOpenButton() {
    let openButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    openButton.setAttribute('width', '24');
    openButton.setAttribute('height', '24');
    openButton.setAttribute('viewBox', '0 0 24 24');

    let openButtonPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    openButtonPath.setAttribute('d', 'M3,0A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Zm9.75,6.75v4.5h4.5a.75.75,0,1,1,0,1.5h-4.5v4.5a.75.75,0,1,1-1.5,0v-4.5H6.75a.75.75,0,0,1,0-1.5h4.5V6.75a.75.75,0,0,1,1.5,0Z');
    openButtonPath.setAttribute('fill', '#fff');

    openButton.appendChild(openButtonPath);

    return openButton;
}